export enum QuickTripCheckReturn {
  unconnected_regions = "unconnected_regions",
  not_routable = "not_routable",
  routable = "routable",
}

type ValhallaRouteSuccess = {
  success: true;
  route: Valhalla_RouteRes;
};

export type ValhallaRouteFailure = {
  success: false;
  error: Valhalla_RouteError;
};

export type ValhallaRouteResult = ValhallaRouteSuccess | ValhallaRouteFailure;

export interface Valhalla_Location {
  lat: number;
  lon: number;
}

export type Valhalla_CostingModel =
  | "auto"
  | "truck"
  | "bus"
  | "taxi"
  | "motor_scooter"
  | "motorcycle";

export type ValhallaErrorCode =
  | 110 // Insufficiently specified required parameter 'locations'
  | 154 // Path distance exceeds the max distance limit
  | 170 // locations in unconnected regions
  | 314 // Too many shape points
  | 400 // Path distance exceeds the max distance limit
  | 412 // No costing method found
  | 441 // Location is unreachable
  | 442 // No path could be found for input
  | number;

export interface Valhalla_RouteError {
  error_code: ValhallaErrorCode;
  error: string;
  status_code: number;
  status: string;
}
export interface Valhalla_RouteRes {
  trip: Valhalla_Trip;
}

export interface Valhalla_Trip {
  locations: Valhalla_DetailedLocation[];
  legs: Valhalla_Leg[];
  summary: Valhalla_Summary;
  status_message: string;
  status: number;
  units: string;
  language: string;
}

export interface Valhalla_Leg {
  maneuvers: Valhalla_Maneuver[];
  summary: Valhalla_Summary;
  shape: string; // polyline
}

interface Valhalla_Maneuver {
  type: number;
  instruction: string;
  verbal_succinct_transition_instruction?: string;
  verbal_pre_transition_instruction: string;
  verbal_post_transition_instruction?: string;
  street_names?: string[];
  begin_street_names?: string[];
  time: number;
  /** Distance in kilometres */
  length: number;
  cost: number;
  begin_shape_index: number;
  end_shape_index: number;
  verbal_multi_cue?: boolean;
  travel_mode: Valhalla_TravelMode;
  travel_type: Valhalla_TravelType;
  verbal_transition_alert_instruction?: string;
  roundabout_exit_count?: number;
  highway?: boolean;
  sign?: Valhalla_Sign;
  ferry?: boolean;
}

interface Valhalla_Sign {
  exit_branch_elements?: Valhalla_ExitElement[];
  exit_toward_elements?: Valhalla_ExitElement[];
  exit_name_elements?: Valhalla_ExitNameElement[];
}

interface Valhalla_ExitElement {
  text: string;
  consecutive_count?: number;
}

interface Valhalla_ExitNameElement {
  text: string;
}

type Valhalla_TravelMode = "drive";

type Valhalla_TravelType = "tractor_trailer" | "ferry" | "car";

interface Valhalla_Summary {
  has_time_restrictions: boolean;
  has_toll: boolean;
  has_highway: boolean;
  has_ferry: boolean;
  min_lat: number;
  min_lon: number;
  max_lat: number;
  max_lon: number;
  time: number;
  /** Distance in kilometres */
  length: number;
  cost: number;
}

interface Valhalla_DetailedLocation {
  type: string;
  lat: number;
  lon: number;
  original_index: number;
  side_of_street?: string;
}
